import React, { Component } from 'react';
import { Form, Row, Col, Input, Modal } from 'antd';

class MyModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      id: '',
      type: '',
      superiorChannelid: '',
      modalTitle: '',
      modalVisible: !1,
    };
  }

  componentDidMount() {
    this.handleInitParams(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.handleInitParams(nextProps);
  }

  handleInitParams = props => {
    const { superiorChannelid, name, id, modalTitle, modalVisible, type } = props || {};
    this.setState({ superiorChannelid, name, id, modalTitle, modalVisible, type });
  };

  handleOk = e => {
    e.preventDefault();
    const me = this;
    const { form, callback } = me.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { type, superiorChannelid, id } = me.state;
        const params = type === 'add' ? { superiorChannelid } : { id };
        callback({ ...params, ...values, modalVisible: !1 });
      }
      form.resetFields();
    });
  };

  handleCancel = () => {
    const { form, callback } = this.props;
    callback({ cancel: !0 });
    form.resetFields();
  };

  render() {
    const { modalTitle, modalVisible, name } = this.state;
    const { form } = this.props;
    const { getFieldDecorator } = form;
    const formItemLayout = {
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
    };
    return (
      <div>
        <Modal
          title={modalTitle}
          centered
          visible={modalVisible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          cancelText=""
        >
          <Row>
            <Col span={24}>
              <Form.Item {...formItemLayout} label="栏目名称">
                {getFieldDecorator('name', {
                  initialValue: name,
                  rules: [
                    {
                      max: 50,
                      message: '请勿超过50个字!',
                    },
                  ],
                })(<Input placeholder="请输入栏目名称" />)}
              </Form.Item>
            </Col>
          </Row>
        </Modal>
      </div>
    );
  }
}

export default Form.create()(MyModal);
